import React from "react";
import "./App.css";
import { SnackbarProvider } from "notistack";
import theme from "./Constants/theme";
import { ThemeProvider } from "@mui/material";
import Container from "./Container";
import { QueryClientProvider, QueryClient, setLogger } from "react-query";
import { TitleProvider } from "./Components/TitleContext/TitleContext"; // Import TitleProvider

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 15 * 60 * 1000,
      staleTime: 60 * 1000,
      retry: false,
    },
  },
});

setLogger({
  log: () => {},
  warn: () => {},
  error: () => {},
});

function App() {
  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
          >
            <TitleProvider> 
              <Container />
            </TitleProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
}

export default App;